// ======productline video play=======

// document.addEventListener("DOMContentLoaded", function () {
//     // str_page_functions();
//     initScrollPlayVideo();
// });


// function initScrollPlayVideo() {
//   const containers = document.querySelectorAll(".sued-scroll-video-container");
//   if (containers.length > 0) {
//     containers.forEach((container) => {
//       const video = container.querySelector("video");
//       const canvas = container.querySelector("canvas");
//       const context = canvas ? canvas.getContext("2d") : null;
//       const startTrigger = container.getAttribute("data-start") || "top center";
//       const endTrigger = container.getAttribute("data-end") || "bottom center";

//       if (video && context && canvas) {
//         // Set the canvas dimensions to match the video dimensions
//         video.addEventListener("loadedmetadata", function () {
//           canvas.width = video.videoWidth;
//           canvas.height = video.videoHeight;

//           ScrollTrigger.create({
//             trigger: container,
//             start: startTrigger,
//             end: endTrigger,
//             scrub: true,
//             onUpdate: (self) => {
//               const progress = self.progress.toFixed(5); // Ensure smooth scrub
//               video.currentTime = video.duration * progress; // Sync video to progress
//               // updateCanvas(video, context); // Render the frame to canvas
//               updateCanvas(video, context, canvas, canvas);
//             },
//           });

//           // Render the first frame to ensure the canvas displays an image initially
//           video.currentTime = 0;
//           video.addEventListener("seeked", () => {
//             // updateCanvas(video, context);
//             updateCanvas(video, context, canvas, canvas);
//           });
//         });
//       }
//     });
//   }
// }

// // function updateCanvas(video, context) {
// //   context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
// // }
// function updateCanvas(b, a, c, d) {
//   d.classList.add("loading");
//   a.drawImage(b, 0, 0, c.width, c.height);
//   setTimeout(function() {
//     d.classList.remove("loading");
//   }, 500);
// }

// ===========new-code===========

// document.addEventListener("DOMContentLoaded", function () {
//     initScrollPlayVideo();
// });

// function initScrollPlayVideo() {
//     const containers = document.querySelectorAll(".sued-scroll-video-container");
//     if (containers.length > 0) {
//         containers.forEach((container) => {
//             const video = container.querySelector("video");
//             const canvas = container.querySelector("canvas");
//             const context = canvas ? canvas.getContext("2d") : null;
//             const startTrigger = container.getAttribute("data-start") || "top center";
//             const endTrigger = container.getAttribute("data-end") || "bottom center";

//             if (video && context && canvas) {
//                 // Set the canvas dimensions to match the video dimensions
//                 video.addEventListener("loadedmetadata", function () {
//                     canvas.width = video.videoWidth;
//                     canvas.height = video.videoHeight;

//                     // Ensure video is ready to play
//                     video.muted = true; // Mute the video for autoplay
//                     video.play().catch(error => {
//                         console.error("Video playback failed:", error);
//                     });

//                     ScrollTrigger.create({
//                         trigger: container,
//                         start: startTrigger,
//                         end: endTrigger,
//                         scrub: 2.5,
//                         onUpdate: (self) => {
//                             const progress = self.progress.toFixed(5); // Ensure smooth scrub
//                             video.currentTime = video.duration * progress; // Sync video to progress
//                             updateCanvas(video, context, canvas);
//                         },
//                     });

//                     // Render the first frame to ensure the canvas displays an image initially
//                     video.currentTime = 0;
//                     video.addEventListener("seeked", () => {
//                         updateCanvas(video, context, canvas);
//                     });
//                 });
//             }
//         });
//     }
// }

// function updateCanvas(video, context, canvas) {
//     context.drawImage(video, 0, 0, canvas.width, canvas.height);
// }

// ============



document.addEventListener("DOMContentLoaded", function () {
  initScrollPlayVideo();
});

function initScrollPlayVideo() {
  const containers = document.querySelectorAll(".sued-scroll-video-container");
  if (containers.length > 0) {
    containers.forEach((container) => {
      const video = container.querySelector("video");
      const canvas = container.querySelector("canvas");
      const context = canvas ? canvas.getContext("2d") : null;
      const startTrigger = container.getAttribute("data-start") || "top center";
      const endTrigger = container.getAttribute("data-end") || "bottom center";

      if (video && context && canvas) {
        // Set the canvas dimensions to match the video dimensions
        video.addEventListener("loadedmetadata", function () {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;

          // Ensure video is ready to play
          video.muted = true; // Mute the video for autoplay
          video.play().catch(error => {
            console.error("Video playback failed:", error);
          });

          ScrollTrigger.create({
            trigger: container,
            start: startTrigger,
            end: endTrigger,
            scrub: true,
            onUpdate: (self) => {
              const progress = self.progress.toFixed(5); // Ensure smooth scrub
              video.currentTime = video.duration * progress; // Sync video to progress
              updateCanvas(video, context, canvas);
            },
          });

          // Render the first frame to ensure the canvas displays an image initially
          video.currentTime = 0;
          video.addEventListener("seeked", () => {
            updateCanvas(video, context, canvas);
          });
        });
      }
    });
  }
}

function updateCanvas(video, context, canvas) {
  context.drawImage(video, 0, 0, canvas.width, canvas.height);
}





// ==========image tab slider=====

class ImageTabSlider {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.tab-button');
    this.slides = container.querySelectorAll('.slider-slide');
    this.overlayImages = container.querySelectorAll('.overlay_image');
    this.currentTab = null;
    this.isAnimating = false;
    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.isAnimating) return;
        const targetId = tab.getAttribute('data-target');
        this.switchTab(targetId);
      });
    });

    // Set initial state
    if (this.tabs.length > 0) {
      this.currentTab = this.tabs[0].getAttribute('data-target');
    }

    // Hide all overlay images except the first one
    if (this.overlayImages.length > 0) {
      this.overlayImages.forEach((image, index) => {
        if (index === 0) {
          image.style.opacity = '1';
          image.style.visibility = 'visible';
        } else {
          image.style.opacity = '0';
          image.style.visibility = 'hidden';
        }
      });
    }
  }

  async switchTab(targetId) {
    if (targetId === this.currentTab) return;
    this.isAnimating = true;

    // Get elements
    const newSlide = this.container.querySelector(targetId);
    const currentSlide = this.container.querySelector('.slider-slide.active');
    const newTab = this.container.querySelector(`[data-target="${targetId}"]`);

    // Get index of new slide for overlay image
    const newIndex = Array.from(this.slides).findIndex(slide => slide === newSlide);
    const currentIndex = Array.from(this.slides).findIndex(slide => slide === currentSlide);

    // Update tabs
    this.tabs.forEach(tab => tab.classList.remove('active'));
    newTab.classList.add('active');

    // Animate slides and overlay images
    if (currentSlide) {
      // Fade out current slide and overlay image
      currentSlide.style.opacity = '0';
      if (this.overlayImages[currentIndex]) {
        this.overlayImages[currentIndex].style.opacity = '0';
        await this.wait(100);
        this.overlayImages[currentIndex].style.visibility = 'hidden';
      }
      await this.wait(100); // Wait for fade out
      currentSlide.classList.remove('active');
    }

    // Fade in new slide and overlay image
    newSlide.classList.add('active');
    await this.wait(50); // Small delay for DOM update
    newSlide.style.opacity = '1';

    if (this.overlayImages[newIndex]) {
      this.overlayImages[newIndex].style.visibility = 'visible';
      await this.wait(50);
      this.overlayImages[newIndex].style.opacity = '1';
    }

    // Update state
    this.currentTab = targetId;
    await this.wait(100); // Wait for fade in
    this.isAnimating = false;
  }

  wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}

// Initialize sliders
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-id]').forEach(container => {
    new ImageTabSlider(container);
  });
});

// Re-initialize on Shopify editor events
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    if (container.hasAttribute('data-section-id')) {
      new ImageTabSlider(container);
    }
  });
}

// ============video-length======

function formatDuration(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

function getVideoDuration() {
  const videoElement = document.querySelector('.sued-product-teaser-html5LightboxVideo');
  const videoMetaDiv = document.querySelector('.sued-video-meta');

  if (!videoElement || !videoMetaDiv) return;

  const desktopVideoUrl = videoElement.getAttribute('data-desktopvideo');
  const mobileVideoUrl = videoElement.getAttribute('data-mobilevideo');

  // Function to update duration based on screen width
  function updateDurationForScreenSize() {
    const isMobile = window.innerWidth < 768; // Adjust breakpoint as needed
    const videoUrl = isMobile ? mobileVideoUrl : desktopVideoUrl;

    const tempVideo = document.createElement('video');
    tempVideo.src = videoUrl;

    tempVideo.addEventListener('loadedmetadata', function () {
      const duration = formatDuration(tempVideo.duration);
      videoMetaDiv.textContent = `Video ${duration}`;
      // Clean up
      tempVideo.remove();
    });

    tempVideo.addEventListener('error', function () {
      console.error('Error loading video duration');
    });
  }

  // Initial duration update
  updateDurationForScreenSize();

  // Update duration when window is resized
  let resizeTimeout;
  window.addEventListener('resize', function () {
    // Debounce resize event
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateDurationForScreenSize, 250);
  });
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', getVideoDuration);


const elements = document.querySelectorAll('.sued-selection-panel .sued-skintan');
elements.forEach(element => {
  element.addEventListener('click', function () {
    const variantId = this.getAttribute('data-variant-id');
    const inputField = document.querySelector('.before_after_section .product-form input[name="id"]');
    if (inputField && variantId) {
      inputField.value = variantId;
    }
  });
});